import React from 'react'
import { START } from 'pu-data/QuoteSteps';
import { useSelector } from 'react-redux';
import SupplierInfoItem from './SupplierInfoItem'

const SupplierInfos = () => {
  const {
    quoteStep,
    suppliers,
  } = useSelector((state) => state.fabrication)

  if (!Spree.supplier_infos) return null;

  if (quoteStep !== START) {
    return null;
  }

  const list = suppliers.map((key) => {
    const supplier = Spree.supplier_infos.find((item) => item.key === key);
    return <SupplierInfoItem key={key} {...supplier} />
  });

  return (
    <div className="product-supplier-infos">
      {list}
    </div>
  )
};

export default SupplierInfos
